/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Calendar_Next_MonthInputs */

const en_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to the Next Month`)
};

const es_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al mes siguiente`)
};

const de_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum nächsten Monat`)
};

const zh_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转到下个月`)
};

const ar_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الانتقال إلى الشهر التالي`)
};

const fr_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au mois suivant`)
};

const vi_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển đến tháng sau`)
};

const sw_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenda mwezi ujao`)
};

const th_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปยังเดือนถัดไป`)
};

const bs_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idi na sljedeći mjesec`)
};

const ja_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翌月へ移動`)
};

const ko_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 달로 이동`)
};

const pt_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o próximo mês`)
};

const it_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai al mese successivo`)
};

const sv_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till nästa månad`)
};

const nl_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar de volgende maand`)
};

const da_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til næste måned`)
};

const nb_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til neste måned`)
};

const fi_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry seuraavaan kuukauteen`)
};

const pl_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do następnego miesiąca`)
};

const ru_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к следующему месяцу`)
};

const tr_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki aya git`)
};

const hi_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले महीने पर जाएँ`)
};

const id_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke bulan berikutnya`)
};

const ms_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke bulan seterusnya`)
};

const cs_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejít na další měsíc`)
};

const el_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μετάβαση στον επόμενο μήνα`)
};

const he_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעבר לחודש הבא`)
};

const af_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaan na volgende maand`)
};

const hu_booking_calendar_next_month = /** @type {(inputs: Booking_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugrás a következő hónapra`)
};

/**
* | output |
* | --- |
* | "Go to the Next Month" |
*
* @param {Booking_Calendar_Next_MonthInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_calendar_next_month = /** @type {((inputs?: Booking_Calendar_Next_MonthInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Calendar_Next_MonthInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_calendar_next_month(inputs)
	if (locale === "de") return de_booking_calendar_next_month(inputs)
	if (locale === "zh") return zh_booking_calendar_next_month(inputs)
	if (locale === "ar") return ar_booking_calendar_next_month(inputs)
	if (locale === "fr") return fr_booking_calendar_next_month(inputs)
	if (locale === "vi") return vi_booking_calendar_next_month(inputs)
	if (locale === "sw") return sw_booking_calendar_next_month(inputs)
	if (locale === "th") return th_booking_calendar_next_month(inputs)
	if (locale === "bs") return bs_booking_calendar_next_month(inputs)
	if (locale === "ja") return ja_booking_calendar_next_month(inputs)
	if (locale === "ko") return ko_booking_calendar_next_month(inputs)
	if (locale === "pt") return pt_booking_calendar_next_month(inputs)
	if (locale === "it") return it_booking_calendar_next_month(inputs)
	if (locale === "sv") return sv_booking_calendar_next_month(inputs)
	if (locale === "nl") return nl_booking_calendar_next_month(inputs)
	if (locale === "da") return da_booking_calendar_next_month(inputs)
	if (locale === "nb") return nb_booking_calendar_next_month(inputs)
	if (locale === "fi") return fi_booking_calendar_next_month(inputs)
	if (locale === "pl") return pl_booking_calendar_next_month(inputs)
	if (locale === "ru") return ru_booking_calendar_next_month(inputs)
	if (locale === "tr") return tr_booking_calendar_next_month(inputs)
	if (locale === "hi") return hi_booking_calendar_next_month(inputs)
	if (locale === "id") return id_booking_calendar_next_month(inputs)
	if (locale === "ms") return ms_booking_calendar_next_month(inputs)
	if (locale === "cs") return cs_booking_calendar_next_month(inputs)
	if (locale === "el") return el_booking_calendar_next_month(inputs)
	if (locale === "he") return he_booking_calendar_next_month(inputs)
	if (locale === "af") return af_booking_calendar_next_month(inputs)
	if (locale === "hu") return hu_booking_calendar_next_month(inputs)
	return en_booking_calendar_next_month(inputs)
});